"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isRef = isRef;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function isRef(obj) {
  return (// eslint-disable-next-line no-prototype-builtins
    obj !== null && _typeof(obj) === 'object' && obj.hasOwnProperty('current')
  );
}


//////////////////
// WEBPACK FOOTER
// ./~/react-dnd/dist/cjs/utils/isRef.js
// module id = 2741
// module chunks = 39